import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EmbedVideoService } from 'ngx-embed-video';
import { environment } from '../../../environments/environment';
import { EventService } from '../../services/event/event.service';
import { HelperService } from '../../services/helper/helper.service';

declare var $;

@Component({
  selector: 'app-view-video-modal',
  templateUrl: './view-video-modal.component.html',
  styleUrls: ['./view-video-modal.component.css'],
})
export class ViewVideoModalComponent implements OnInit, AfterViewInit {
  @ViewChild('showBtn')
  public showModalBtn: ElementRef;

  public iframeHtml: any;
  public video = null;

  constructor(
    private event: EventService,
    private embedService: EmbedVideoService,
    private sanitizer: DomSanitizer,
    private helper: HelperService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.event.on('view-video-modal', 'showViewVideoModal', (video) => {
      this.initVideo(video);
    });
  }

  ngAfterViewInit() {
    $('#viewVideoModal').on('hidden.bs.modal', () => {
      this.iframeHtml = '';
      this.cdRef.detectChanges();
      setTimeout(() => {
        console.log($('.modal.in').length);
        if ($('.modal.in').length) {
          $('body').addClass('modal-open');
        }
      }, 100);
    });
  }

  show(video) {
    this.showModalBtn.nativeElement.click();
    this.initVideo(video);
  }

  private initVideo(video: any) {
    this.video = video;
    if (this.video.videoUrl) {
      if (this.video.videoUrl.includes(environment.apiUrl)) {
        const url = this.video.videoUrl;
        const iframe = `<iframe src="${url}" width="100%" height="300" frameborder="0" allowfullscreen></iframe>`;
        this.iframeHtml = this.sanitizer.bypassSecurityTrustHtml(iframe);
      } else {
        this.iframeHtml = this.embedService.embed(this.video.videoUrl, {
          query: { portrait: 0, color: '333', autoplay: 1 },
          attr: { width: '100%', height: 300, allow: 'autoplay' },
        });
      }
    } else if (this.video.extension) {
      const url = this.helper.getDownloadablePath(video);
      const iframe = `<iframe src="${url}" width="100%" height="300" frameborder="0" allowfullscreen></iframe>`;
      this.iframeHtml = this.sanitizer.bypassSecurityTrustHtml(iframe);
    } else {
      this.iframeHtml = this.embedService.embed(video.path, {
        query: { portrait: 0, color: '333', autoplay: 1 },
        attr: { width: '100%', height: 300, allow: 'autoplay' },
      });
    }
    console.log(this.video);
    console.log(this.iframeHtml);
  }
}



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/app/shared/view-video-modal/view-video-modal.component.ts